module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C124"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("CONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "C134"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/06_ACKNOWLEDGMENTS#page_ix"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_ABBREVIATIONS#page_xiii"
    }
  }, [_vm._v("ABBREVIATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "C134"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_INTRODUCTION#page_1"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "C134"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_CHAPTER_1__Farm_Worker_Organizin#page_15"
    }
  }, [_vm._v("CHAPTER 1. Farm Worker Organizing and the Advent of the UFW: 1900 to 1993")])]), _vm._v(" "), _c('p', {
    staticClass: "C134"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_CHAPTER_2__Dolores_Huerta_s_Life#page_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 2. Dolores Huerta’s Life: Intersectional Habitus as Rhetorical Agency")])]), _vm._v(" "), _c('p', {
    staticClass: "C134"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_CHAPTER_3__Letters_to_C_sar_Ch_v#page_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 3. Letters to César Chávez: Building Collaborative Agency")])]), _vm._v(" "), _c('p', {
    staticClass: "C134"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_CHAPTER_4__Motherhood__Familia#page_77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 4. Motherhood, Familia, Emotionality: Strategic Use of Gendered Public Persona")])]), _vm._v(" "), _c('p', {
    staticClass: "C134"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_CHAPTER_5__Public_Persona_of_Dif#page_106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 5. Public Persona of Differential Bravery through Collaborative Egalitarianism and Courageous Optimism")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_CHAPTER_6__Dolores_Huerta__Iconi#page_134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 6. Dolores Huerta, Iconicity, and Social Movements")])]), _vm._v(" "), _c('p', {
    staticClass: "C134"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_EPILOGUE#page_154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EPILOGUE")])]), _vm._v(" "), _c('p', {
    staticClass: "C134"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_REFERENCES#page_164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("REFERENCES")])]), _vm._v(" "), _c('p', {
    staticClass: "C134"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_INDEX#page_179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d06ac474","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Contents.vue
// module id = 75
// module chunks = 0